<template>
<div class="card">
	<div class="dash-card-header"> 
		<div class="back-link pl-2">
			<button @click="hasHistory() ? $router.go(-1) : $router.push('/dashboard')">
				<img class="pull-left" src="@/assets/back.svg">	
			</button>
		</div>
		<div class="title-div font-medium font-size-15"><img src="@/assets/fitme-quarter.svg" class="color-purple"> {{$t("register_acc")}}</div>
		<div class="logout-link">
			<!-- <img class="" src="@/assets/logout.svg" @click="logout"> -->
		</div>
	</div>	
	<div class="col-sm-12 p-12 f-16">
		 <h2>{{$t("lfajtapm")}}</h2>
	</div>
	<div class=" pt-20 justify-center items-center color-custom">	      
			<div class="form-group col-sm-12">
				<input type="text" class="form-control bg-color-grblue-border" ref="name" :placeholder='$t("fname")' v-model="form.name" required>
			</div>
			<div class="form-group col-sm-12">
				<input type="text" class="form-control bg-color-grblue-border" ref="surname"  :placeholder='$t("lastname")' v-model="form.lastname" required>
			</div>
			<div class="form-group col-sm-12">
				<input type="email" class="form-control bg-color-grblue-border" ref="email" :placeholder='$t("email")' v-model="form.email" required>
			</div>
			<div class="form-group col-sm-12">
				<input type="text" v-on:keypress="checkNumOnly($event)" class="form-control bg-color-grblue-border" ref="phone" :placeholder='$t("phone")' v-model="form.phone" required>
			</div>
			<div class="form-group col-sm-12">
				<input class="form-control bg-color-grblue-border" :placeholder='$t("password")' type="password" v-model="form.password" ref="password" required>
			</div>
			<div v-if="errorMsg"  class="form-group col-sm-12 text-center">
				<div class=" btn-danger p-8" ref="errormsg">{{errorMsg}}</div>
			</div>
			<br>
			<div v-if="!form.email" class="form-group col-sm-12">
				<button @click.prevent="saveForm" type="submit" class="btn bg-color-grblue btn-block">{{$t("register")}}</button>
			</div>
			<div v-if="form.email" class="form-group col-sm-12">
				<button @click.prevent="saveForm" type="submit" class="btn bg-color-grblue btn-block">{{$t("next")}}</button>
			</div>
			<div class="col-sm-12 p-6 colo-rblack">
				{{$t("bcryawt")}} <a target="_blank" class="color-blue" :href='$t("conditionsURL")'>{{$t("tos")}}</a> {{$t("ofjycf")}} 
					<a target="_blank" class="color-blue" :href='$t("privacyURL")'>{{$t("here")}}</a>.
			</div>
    </div>
</div>
</template>
<script>
export default {
	props: ['companyslug'],
    data(){
        return {
            form:{
                name: '',
                email: '',
                password:'',
                phone:  '',
                lastname: '',
				companyslug: this.$route.params.companyslug,
				locale: 'en-en'
            },
            error: 0,
			errorMsg: ''
        }
    },
	mounted() {
		window.scrollTo(0,0)
	},
	created() {
		let user = JSON.parse(localStorage.getItem('user'))
		if (user) {
			if(user.name) {
				this.form.name = user.name
			}
			if(user.email) {
				this.form.email = user.email
			}
			if(user.phone) {
				this.form.phone = user.phone
			}
			if(user.surname) {
				this.form.lastname = user.surname
			}


      localStorage.setItem('locale', user.locale); // localStorage.setItem('locale') = user.locale
		}		
	},
    methods:{
		hasHistory () { return window.history.length > 2 },
		async saveForm(){ 
			this.$refs.name.classList.remove('bg-color-red-border')
			this.$refs.surname.classList.remove('bg-color-red-border')
			this.$refs.email.classList.remove('bg-color-red-border')
			this.$refs.password.classList.remove('bg-color-red-border')
			this.$refs.phone.classList.remove('bg-color-red-border')

			this.error = 0;
			if (!this.form.name) {
				this.error++
				this.$refs.name.classList.add('bg-color-red-border')
			}
			if (!this.form.lastname) {
				this.error++
				this.$refs.surname.classList.add('bg-color-red-border')
			}
			if (!this.form.email) {
				this.error++
				this.$refs.email.classList.add('bg-color-red-border')
			}else if (!this.validEmail(this.form.email)) {
				this.$refs.email.classList.add('bg-color-red-border')
				
				return
			}
			if (!this.form.password) {
				this.$refs.password.classList.add('bg-color-red-border')
				this.error++
			} else if (this.form.password.length < 6) {
				this.$refs.password.classList.add('bg-color-red-border')
				this.errorMsg = this.$t("psbal6")
				return;
			}
			if (!this.form.phone) {
				this.$refs.phone.classList.add('bg-color-red-border')
				this.error++
			}

			if(this.error > 0) {
				this.errorMsg = this.$t("perd")
				return;
			}
			this.form.locale = localStorage.getItem('locale');
         
			try { 
				let res = await this.$store.dispatch('register', this.form);
				if (res.success) {
					await this.$router.push({ name: 'registerAddress'});
					return;
				}
				this.error++
				this.errorMsg = res.message


			} catch (error) {
				if(error.response && error.response.data && error.response.data.message) {
					if (error.response.data.errors.email) {
						this.errorMsg =  this.$t("teiais")
						return;
					}
					this.errorMsg = error.response.data.message;
				}
			} 
		},
		validEmail: function (email) {
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		checkNumOnly(e) {
			let char = String.fromCharCode(e.keyCode);
            if (/^[0-9]+$/.test(char)) return true;
            else e.preventDefault();
		}
    }
}
</script>

<style scoped>

</style>
